import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'objectValue',
	standalone: true,
})
export class ObjectValuePipe implements PipeTransform {
	transform<T>(value?: { [key in any]: T }): Array<T> {
		if (!value) return [];
		return Object.values(value);
	}
}
